"use client";

import React, { useState, useEffect } from "react";
import overviewImg from "../../assets/course-details/overview.svg";
import SectionHeading from "../shared/SectionHeading";

// import PopUp from "../popup/PopUp";

const CourseOverview = ({ data }) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);

  const handleButtonClick = () => {
    setIsPopUpOpen(true);
  };

  const handleClosePopUp = () => {
    setIsPopUpOpen(false);
  };

  // useEffect(() => {
  //   console.log("data", data);
  // }, []);

  if (!data.section[0].isActive) {
    return <div></div>;
  }

  return (
    <div className="px-4 lg:px-16 mx-auto max-w-[1440px]">
      <SectionHeading>
        <span className="text-primary-color">Course</span>{" "}
        <span className="text-secondary-color">Overview</span>
      </SectionHeading>

      <div className="mt-10 flex flex-col lg:flex-row gap-10 lg:gap-16 items-center justify-between">
        {/* Image Section */}
        <img
          src={overviewImg}
          alt="Overview"
          className="w-full lg:w-[45%] max-w-[500px] object-contain"
        />

        {/* Text Section */}
        <div className="text-center lg:text-left">
          <ul className="mt-2 list-disc text-base lg:text-18 leading-6 px-6 lg:px-0">
            {data.section[0].body.list1.map((item, index) => (
              <li key={index} className="mb-3 leading-relaxed">
                {item.text}
              </li>
            ))}
          </ul>

          {/* Call-to-Action Button */}
          <button
            className="mt-8 lg:mt-12 px-6 py-3 text-center text-[14px] font-semibold text-white bg-primary-color rounded-lg shadow-lg hover:bg-primary-dark transition duration-300 flex items-center gap-2 w-fit"
            onClick={handleButtonClick}
          >
            Let&apos;s Get Started
            {/* Right arrow SVG */}
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/></svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseOverview;
